import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';

import type { Theme as MuiTheme } from '@mui/material';
import type { ThemeProviderProps } from './types';

declare module '@emotion/react' {
  interface Theme extends MuiTheme {}
}

const ThemeProvider = (props: ThemeProviderProps) => {
  const { children, theme } = props;

  return (
    <MuiThemeProvider theme={theme}>
      <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
    </MuiThemeProvider>
  );
};

export default ThemeProvider;
